import React, { PropsWithChildren } from "react";
import InvoiceFilter from "./InvoiceFilter";
import InvoiceTable from "./InvoiceTable";
import { InvoiceProvider } from "../../providers/InvoiceProvider";
import { withUIProtection } from "../../hoc/withUIProtection";

type Props = PropsWithChildren & {
  asContainer?: boolean;
};

const Invoice = ({ children, asContainer = true, ...rest }: Props) => {
  return (
    <InvoiceProvider {...rest}>
      <div data-name="invoice">{children}</div>
    </InvoiceProvider>
  );
};

// Apply UI protection to the subcomponents
const ProtectedInvoiceFilter = withUIProtection(InvoiceFilter);
const ProtectedInvoiceTable = withUIProtection(InvoiceTable);

// Attach the protected subcomponents to the ProtectedPayment component
Invoice.InvoiceFilter = ProtectedInvoiceFilter;
Invoice.InvoiceTable = ProtectedInvoiceTable;

export { Invoice };

// Export individual protected components
export {
  ProtectedInvoiceFilter as InvoiceTable,
  ProtectedInvoiceTable as InvoiceFilter,
};
